module.exports = __webpack_public_path__ + "img/test_hp_07.png";